/* newId — collision-proof ids for records that sync to the cloud.
   Quotes, customers, projects and work orders share global primary keys
   across every workspace; the old `"q" + Date.now()` (a millisecond) let two
   contractors mint the same id and one tenant's sync would then fail forever
   on the other's row. The prefix + time-order stay (the UI shows the last six
   characters as the estimate number), a random suffix makes them unique. */
export function newId(prefix = ""): string {
  let rnd = "";
  try {
    const b = new Uint8Array(6);
    crypto.getRandomValues(b);
    rnd = Array.from(b, (x) => x.toString(16).padStart(2, "0")).join("");
  } catch (e) {
    rnd = Math.random().toString(16).slice(2, 14).padEnd(12, "0");
  }
  return prefix + Date.now().toString(36) + "-" + rnd;
}
